import { ReactNode } from "react";
import { createUseStyles } from "react-jss";

interface Props {
  children?: ReactNode;
}

const useStyles = createUseStyles({
  root: {
    position: "relative",
    maxWidth: "1440px",
    width: "100%",
    margin: "0 auto",
    "@media (max-width: 1480px)": {
      width: "100%",
    },
  },
});

const ContentWrapper = ({ children }: Props) => {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};

export default ContentWrapper;
